// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__3yd8l","img":"index_img__1JJZy","box":"index_box__i-GnX","txt":"index_txt__1r21z","progress":"index_progress__1SCaO"};